export const findItemInResults = (list, address, obj) => {
  const item = list.find(i => i.address === address);
  if (!item) {
    return obj;
  }
  return item;
}